import * as React from 'react';
import { History } from 'history';
import { FormattedMessage } from 'react-intl';
import img from '../../images/contact-us-1908762_1920.png';

interface IProps {
    history: History;
}

export default (props: IProps) => {
    return (
        <section className="contactContent">
            <div className="container">
                <div className="row">
                    <div className="col-sm-12">
                        <img src={img} alt="" className="mainImage" />
                        <h2><a href="mailto:info@myharmonize.com">info@myharmonize.com</a></h2>
                        <h2><a href="tel:+13055350914">(305) 535-0914</a></h2>
                        <h2><br/>1313 Ponce de Leon Blvd.
                            <br/>Suite 301
                            <br/>Coral Gables, FL 33134
                        </h2>
                    </div>
                </div>
            </div>
        </section>
    )
}


// WEBPACK FOOTER //
// ./src/client/dashboard/Contact.tsx